export const IMPORTED_PATIENT = 'imported_patient';

export const DELIMITER_OPTS = [
  { label: 'Comma Separated', value: ',' },
  { label: 'Pipe Separated', value: '|' },
  { label: 'Tab Separated', value: '\t' },
];

export const PATIENT_MAPPINGS = [
  { label: 'Patient Name', key: 'name' },
  { label: 'Patient ID', key: 'externalId' },
  { label: 'Date of Birth', key: 'dateOfBirth' },
  { label: 'Gender', key: 'sex' },
  { label: 'Hospital Admission Date', key: 'hospitalAdmissionDate', optional: true },
  { label: 'Network Provider Admission Date', key: 'providerAdmissionDate', optional: true },
  { label: 'Address 1', key: 'address1', optional: true },
  { label: 'Address 2', key: 'address2', optional: true },
  { label: 'City', key: 'city', optional: true },
  { label: 'State', key: 'state', optional: true },
  { label: 'Zip', key: 'zip', optional: true },
  { label: 'Phone Number', key: 'phoneNumber', optional: true },
];
